import { inject, injectable } from 'inversify';
import AddressesRepository from '../../data/AddressesRepository';
import { DeleteAddressParams } from 'src/features/addresses/domain/AddressesRepositoryInterface';
import { DeleteAddressResponse } from 'src/features/addresses/data/service/addressesService.types';

interface DeleteAddressUseCaseInterface {
  execute(params: DeleteAddressParams): Promise<DeleteAddressResponse>;
}

@injectable()
class DeleteAddressUseCase implements DeleteAddressUseCaseInterface {
  @inject(AddressesRepository)
  private addressesRepository!: AddressesRepository;

  async execute(params: DeleteAddressParams) {
    return this.addressesRepository.deleteAddress(params);
  }
}

export default DeleteAddressUseCase;
